//import html2canvas from 'html2canvas'
import {
    db
  } from '../../firebase/firebaseConfig.js'

export default {




    'UPDATE_SURVEY_FLOW': ({
        dispatch,
        state,
        rootState
      }) => {        
        
        
        //THIS SHOULD BE MOVED TO BACKEND!


        return new Promise(async (resolve, reject) => {
          const toPush = {
              surveySetup: {...state.surveySetup}
          }
          toPush.surveySetup.surveyFlow = [...state.surveyFlow]                    


          //sync open, multi and single
          for (const step of toPush.surveySetup.surveyFlow) {            
            if (step.type === 'multiq' || step.type === 'openq' || step.type === 'singleq') {
                //add to DaBa
                //noconsoleconsole.log(`adding new q ${step.content.ask}`)
                await dispatch('dash/ADD_NEW_QUESTION', {
                  questionID: step.questionID,
                  questionType: step.type,
                  answerOptions: typeof step.answerOptions !== 'undefined' ? step.answerOptions : null,
                  questionText: step.content.ask
                }, {root:true})
            }
          }

          db.collection('entities').doc(rootState.dash.viewData.business.businessID).update(toPush).then(() => {
            resolve()
          }).catch((e) => {
            //noconsoleconsole.log(e)
            reject()
          })
        })

      }
}